'use strict';

/*@ngInject*/
export function FilesUtilFactory($q, $state, $rootScope, appConfig, Files) {
  function remove(id) {
    let deferred = $q.defer();
    Files.delete({
      id: id
    }).$promise.then(res => {
      deferred.resolve(res);
    }, err => {
      deferred.reject(err);
    });
    return deferred.promise;
  }

  function read(id) {
    let deferred = $q.defer();
    Files.read({
      id: id
    }).$promise.then(res => {
      deferred.resolve({
        _id: res._id,
        filename: res.filename
      });
    }, err => {
      deferred.reject(err);
    });
    return deferred.promise;
  }

  function checksum(file) {
    let deferred = $q.defer();
    let reader = new FileReader();
    reader.onloadend = () => {
      let content = CryptoJS.lib.WordArray.create(reader.result);
      let hash = CryptoJS.SHA256(content).toString();
      deferred.resolve(hash);
    };
    reader.onerror = err => {
      deferred.reject(err);
    };
    // TODO: use this for progressbar maybe? otherwise take out
    reader.onprogress = evt => {
      deferred.notify(evt);
    };

    reader.readAsArrayBuffer(file);
    return deferred.promise;
  }

  function getImage(image) {
    if(image && image.hasOwnProperty('filename') && _.isString(image.filename)) {
      return appConfig.paths.IMAGES + image.filename;
    }
    return image;
  }

  function getThumbnail(image) {
    if(image && image.hasOwnProperty('filename') && _.isString(image.filename)) {
      return appConfig.paths.IMAGES + image._id + '/thumb.jpg';
    }
    return image;
  }

  // Public API here
  return {
    read: read,
    remove: remove,
    checksum: checksum,
    getThumbnail: getThumbnail,
    getImage: getImage
  };
}

export default angular.module('fplTruescapeComApp.FilesUtil', [])
  .factory('FilesUtil', FilesUtilFactory)
  .name;



// WEBPACK FOOTER //
// ./client/components/Files/FilesUtil.service.js